import * as React from "react";

import {Errors, KAError} from "@khan/logging";

import {ApolloRouterContext} from "./apollo-router-context.ts";
import type {ApolloGqlClient} from "./types.ts";

/**
 * Result of the `useGql` hook.
 */
interface Output {
    /**
     * The current GQLClient instance.
     */
    readonly gqlClient: ApolloGqlClient;
}

/**
 * Get the current client instance for Apollo operations and default module.
 *
 * @returns {Output} An object containing the current client instance
 * and default GAE module that Apollo-based operations should use.
 */
export const useApolloGqlClient = (): Output => {
    const {client} = React.useContext(ApolloRouterContext);
    if (client == null) {
        if (process.env.NODE_ENV === "production") {
            throw new KAError("No GqlRouter", Errors.Internal);
        } else {
            throw new KAError(
                "No GqlRouter defined; did you forget a gql test harness adapter config?",
                Errors.Internal,
            );
        }
    }

    return {
        gqlClient: client,
    };
};
